import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { CYBERSOURCE_COMPLETE_3DS } from "../../CybersourcePaymentService/graphql/cybersourceComplete3ds.mutation";

const log: any = LoggerModule?.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICostumeComplete3dsMethods extends IPluginMethodMap {
  cybersourceComplete3ds(args: any): Promise<any>;
}

export class CostumeComplete3dsService implements IAgentPlugin {
  readonly methods: ICostumeComplete3dsMethods;

  constructor() {
    this.methods = {
      cybersourceComplete3ds: this.cybersourceComplete3ds.bind(this),
    };
  }

  async cybersourceComplete3ds(args: any) {
    log.blue("costumePageService cybersourceComplete3ds args:", args);

    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    if (!client) {
      throw new Error("GraphQL client not found");
    }

    const input = args?.data || {};

    const data = {
      payOrder: input?.payOrder,
      sessionId: input?.sessionId,
      transientToken: input?.transientToken,
      authenticationTransactionId: input?.authenticationTransactionId,
      amount: Number(input?.amount),

      firstName: input?.firstName,
      lastName: input?.lastName,
      email: input?.email,
      mobile: input?.mobile,

      addressLine1: input?.addressLine1,
      city: input?.city,
      state: input?.state,
      country: String(input?.country || "").toUpperCase(),
      postalCode: input?.postalCode,
    };

    try {
      const res = await client.mutate({
        mutation: CYBERSOURCE_COMPLETE_3DS,
        variables: { data },
        fetchPolicy: "no-cache",
      });

      return {
        res: res?.data?.cybersourceComplete3ds,
        url: null,
      };
    } catch (err: any) {
      const displayMessage =
        err?.graphQLErrors?.find((item: any) => item?.extensions)?.extensions
          ?.display_message ||
        err?.message ||
        "CyberSource complete 3DS failed";

      throw new Error(displayMessage);
    }
  }
}
